module.exports = __webpack_public_path__ + "img/401.6b04359d.svg";